module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_lp-data__box-img02-9d5a903852be801ab37c222c81658d57.png";